const UNTYPED_CATEGORY_KEY = '__untyped_category__';

// Categoria fuera del catalogo: se muestra el identificador formateado en vez de
// esconder las tareas (guiones bajos por espacios, capitalizado).
export const formatCategoryKey = (categoryKey) => {
  const spaced = String(categoryKey || '').replace(/_/g, ' ').trim();
  return spaced ? spaced.charAt(0).toUpperCase() + spaced.slice(1) : '';
};

/**
 * Filas del desglose por tipo de una card: solo las categorias con al menos una tarea,
 * en el orden fijo del catalogo, mas "Sin tipo" cuando el total supera a la suma del
 * desglose (tareas cuyo tipo no tiene categoria asociada).
 */
export const buildCategoryRows = (loadByCategory = {}, tasksLoad = 0, catalog = {}) => {
  const { displayNameByName, orderIndexByName } = catalog;

  const rows = Object.entries(loadByCategory)
    .filter(([, count]) => count > 0)
    .map(([categoryKey, count]) => ({
      key: categoryKey,
      label: displayNameByName?.get(categoryKey) || formatCategoryKey(categoryKey),
      count,
      orderIndex: orderIndexByName?.has(categoryKey)
        ? orderIndexByName.get(categoryKey)
        : Number.MAX_SAFE_INTEGER
    }))
    .sort((left, right) => (
      left.orderIndex - right.orderIndex || left.label.localeCompare(right.label, 'es')
    ));

  // El total mostrado nunca puede quedar por encima de la suma de las filas
  const detailSum = rows.reduce((sum, row) => sum + row.count, 0);
  const untypedCount = Math.max(tasksLoad - detailSum, 0);

  if (untypedCount > 0) {
    rows.push({
      key: UNTYPED_CATEGORY_KEY,
      label: 'Sin tipo',
      count: untypedCount,
      orderIndex: Number.MAX_SAFE_INTEGER
    });
  }

  return rows;
};
